
export default {
  name: 'icon-status-checkin',
};
